import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { MenuService } from '@core/services/menu/menu.service';
import { CartService } from '@core/services/cart/cart.service';
import { CustomizationService } from '@core/services/customization/customization.service';

import { CustomizationUtilService } from '@core/services/customization-util/customization-util.service';
import { PonchoUIModule } from '@poncho/ui';
@Component({
    selector: 'app-cross-brand-order-reset',
    templateUrl: './cross-brand-order-reset.component.html',
    styleUrls: ['./cross-brand-order-reset.component.scss'],
    standalone: true,
    imports: [MatDialogModule, PonchoUIModule]
})

export class CrossBrandOrderResetComponent implements OnInit, OnDestroy {

    menuModel: any;

    destroySubject$: Subject<void> = new Subject();

    preSelectedBrand: string;
    currentItemBrand: string;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<CrossBrandOrderResetComponent>,
        private menuService: MenuService,
        private cartService: CartService,
        private customizationService: CustomizationService,
        private customizationUtil: CustomizationUtilService
    ) {
        this.preSelectedBrand = this.data.preSelectedBrand;
        this.currentItemBrand = this.data.currentItemBrand;
    }

    ngOnInit() {
        this.menuService.menuModel
            .pipe(takeUntil(this.destroySubject$))
            .subscribe(data => { this.menuModel = data; });
    }

    ngOnDestroy() {
        this.destroySubject$.next();
        this.destroySubject$.complete();
    }
    
    resetCart() {
        this.cartService.resetCart();
        this.addToCart();
        this.close();
    }

    close() {
        this.dialogRef.close();
    }

    addToCart() {
        const productId = this.data.productId;
        if(!this.cartService.checkMaxLimit(productId, this.menuModel)){
            return ;
        }

        if (this.customizationService.toShowCustomizationModal(productId, this.menuModel)) {
            return this.customizationUtil.openCustomizationModel({product_id: productId}, this.menuModel);
        }

        const productSize = this.menuModel.products[productId].product_sizes[0];
        let customizaitonString = '';
        if (productSize.product_customization_types.length > 0) {
            customizaitonString = this.customizationService.getDefaultCustomizationsString(productSize.product_customization_types);
        }
        this.cartService.addItem(productId, productSize.id, customizaitonString, this.data.payload);
    }

    
}
